<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="universal-vcard">
      <v-card-title>
        <div class="universal-vdialog-title">
          <span>{{ $t('office_management.service_type.' + (isEditMode ? 'edit' : 'add')) }} {{ $t('office_management.service_type.type') }}</span>
        </div>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="formValid">
          <v-text-field
            v-model="formData.name"
            :label="$t('office_management.service_type.name')"
            :rules="[rules.required]"
            class="universal-vdialog-textfield"
            required
          ></v-text-field>

          <div class="container">
            <div class="form-input-wrapper">
              <label class="form-label">
                <span>{{ $t('office_management.service_type.additional_description') }}</span>
              </label>
              <textarea
                class="form-textarea"
                v-model="formData.description"
                label="Description"
                :rules="[rules.required]"
                required
              ></textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <div class="vdialog-buttons-wrapper wrapper-three-buttons">
        <div
          class="universal-vdialog-button vbutton-secondary"
          text
          @click="close"
        >
          {{ $t('office_management.service_type.cancel') }}
        </div>
        <div
          class="universal-vdialog-button vbutton-primary"
          text
          @click="save"
        >
          {{ $t('office_management.service_type.save') }}
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ServiceTypeDialog",
  data() {
    return {
      dialog: false,
      formData: {
        name: "",
        description: "",
      },
      isEditMode: false,
      formValid: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    open(data = null) {
      this.dialog = true;
      if (data) {
        this.isEditMode = true;
        this.formData = { ...data };
      } else {
        this.isEditMode = false;
        this.formData = {
          name: "",
          description: "",
        };
      }
    },
    close() {
      this.dialog = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit(this.isEditMode ? "update" : "create", this.formData);
        this.close();
      }
    },
  },
};
</script>
